import { render, staticRenderFns } from "./draggable_compat.vue?vue&type=template&id=371da4cf&vue3"
import script from "./draggable_compat.vue?vue&type=script&lang=js&vue3"
export * from "./draggable_compat.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports